import React, { useState, useEffect, useRef } from "react";
import "./HorizontalDatePicker.css";
import { useStateValue } from "../context/StateProvider";
import moment from "moment";
import { FaCircleCheck } from "react-icons/fa6";
import { FaCheckDouble } from "react-icons/fa6";
import { RiCheckDoubleLine } from "react-icons/ri";
import { MdCancel } from "react-icons/md";
import { MdPending } from "react-icons/md";
const HorizontalDattePickerWrap = ({
  startDate,
  endDate,
  selectedDate: initialSelectedDate,
  onDateSelected,
  supervisortasks,
}) => {
  const [selectedDate, setSelectedDate] = useState(
    initialSelectedDate || new Date()
  );
  const [dates, setDates] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(selectedDate.getMonth());
  const [currentYear, setCurrentYear] = useState(selectedDate.getFullYear());
  const datePickerRef = useRef(null);
  const dateRefs = useRef([]);

  const [{ clients, employees }, dispatch] = useStateValue();

  // Generate dates for the selected month and year
  useEffect(() => {
    const newDates = [];
    const date = new Date(currentYear, currentMonth, 1);
    while (date.getMonth() === currentMonth) {
      if (date >= startDate && date <= endDate) {
        newDates.push(new Date(date));
      }
      date.setDate(date.getDate() + 1);
    }
    setDates(newDates);
  }, [currentMonth, currentYear, startDate, endDate]);

  // Scroll to selected date on first render
  useEffect(() => {
    if (datePickerRef.current && selectedDate && dateRefs.current.length > 0) {
      const index = dates.findIndex(
        (date) => date.toDateString() === selectedDate.toDateString()
      );
      if (index !== -1 && dateRefs.current[index]) {
        const selectedDateElement = dateRefs.current[index];
        const offsetLeft = selectedDateElement.offsetLeft;
        const containerWidth = datePickerRef.current.offsetWidth;
        const elementWidth = selectedDateElement.offsetWidth;

        datePickerRef.current.scrollTo({
          left: offsetLeft - containerWidth / 2 + elementWidth / 2,
          behavior: "smooth",
        });
      }
    }
  }, [dates, selectedDate]);

  const handleDateClick = (date) => {
    setSelectedDate(date);
    onDateSelected && onDateSelected(date);
  };

  const handleMonthChange = (event) => {
    const [year, month] = event.target.value.split("-");
    setCurrentYear(parseInt(year, 10));
    setCurrentMonth(parseInt(month, 10));
  };

  const handleScroll = () => {
    if (dateRefs.current.length > 0) {
      const containerCenter =
        datePickerRef.current.scrollLeft +
        datePickerRef.current.offsetWidth / 2;
      let closestDate = dates[0];
      let minDistance = Math.abs(
        containerCenter - dateRefs.current[0].offsetLeft
      );

      dateRefs.current.forEach((dateRef, index) => {
        if (dateRef) {
          const distance = Math.abs(
            containerCenter - (dateRef.offsetLeft + dateRef.offsetWidth / 2)
          );
          if (distance < minDistance) {
            minDistance = distance;
            closestDate = dates[index];
          }
        }
      });

      if (closestDate) {
        setCurrentMonth(closestDate.getMonth());
        setCurrentYear(closestDate.getFullYear());
      }
    }
  };

  const getTasksForDate = (date) => {
    const dateStr = moment(new Date(date)).format("YYYY-MM-DD");

    return supervisortasks.filter((t) => t.deadlinedate === dateStr);
  };

  const grouptasks = (tasks) => {
    if (!Array.isArray(tasks) || tasks.length === 0) return [];

    const grouped = tasks.reduce((acc, task) => {
      const date = task.reminderdate || task.deadlinedate;
      const projectid = task.projectid || "unknown";

      if (!date) return acc; // skip invalid entries

      const key = `${projectid}_${date}`;

      if (!acc[key]) {
        acc[key] = {
          projectid,
          date,
          data: [],
        };
      }

      acc[key].data.push(task);

      return acc;
    }, {});

    // 🔹 Convert object to array so you can map over it later
    return Object.values(grouped);
  };

  return (
    <div className="date-picker-container">
      <div className="sticky-header">
        <select
          value={`${currentYear}-${currentMonth}`}
          onChange={handleMonthChange}
        >
          {generateMonthOptions(startDate, endDate)}
        </select>
      </div>

      <div
        className="horizontal-date-picker flex flex-wrap"
        ref={datePickerRef}
        onScroll={handleScroll}
      >
        {dates.map((date, index) => {
          const isSelected =
            selectedDate && selectedDate.toDateString() === date.toDateString();
          const dayName = date.toLocaleDateString("default", {
            weekday: "short",
          });
          const dayNumber = date.getDate();

          const dayTasks = getTasksForDate(date);

          const hasTasks = dayTasks.length > 0;
          const groupedtasks = grouptasks(dayTasks);

          console.log("groupedtasks" + JSON.stringify(groupedtasks));

          return (
            <div
              key={date.toISOString()}
              ref={(el) => (dateRefs.current[index] = el)}
              className={` date-itemwrap ${isSelected ? "selected" : ""}  `}
              onClick={() => handleDateClick(date)}
            >
              <div className="day-name">{dayName}</div>
              <div className="day-number">{dayNumber}</div>
              {hasTasks && (
                <div className="w-full p-[10px] overflow-y-scroll ">
                  {dayTasks.length &&
                    groupedtasks.map((item, innerindex) => {
                      const companydata = clients.find(
                        (project) => project.id === item?.projectid
                      );
                      return (
                        <div className="flex flex-row items-start py-[5px] border border-b-1 border-t-0 border-r-0 border-l-0  border-bordercolor ">
                          <img loading="lazy"
                            src={companydata?.logo}
                            className="w-[30px] h-[30px] rounded-full object-cover  bg-cardOverlay  drop-shadow-lg"
                          />
                          <div className="flex flex-col ml-[5px]  w-full ">
                            {item.data.map((inneritem, innermostindex) => {
                              return (
                                //    ? "text-red-600"
                                // : item?.Status == "Completed"
                                // ? "text-themegreen"
                                // : "text-orange-500"
                                <div
                                  className={`flex flex-col items-start w-full ${
                                    inneritem.Status == "Rejected"
                                      ? "bg-red-300"
                                      : ""
                                  } rounded-md p-[5px] mb-[5px]`}
                                >
                                  <div className="flex flex-row items-center w-full mb-[2px] ">
                                    <div>
                                      {inneritem.Status == "Completed" ? (
                                        <FaCircleCheck className="text-[12px]  text-themegreen" />
                                      ) : inneritem.Status == "Rejected" ? (
                                        <MdCancel className="text-[13px]  text-red-600" />
                                      ) : (
                                        <MdPending className="text-[13px]  text-themegray" />
                                      )}
                                    </div>
                                    {inneritem.completiontimestamp >
                                      inneritem.deadlinetimestamp ||
                                      (Date.now() >
                                        inneritem.deadlinetimestamp &&
                                        inneritem.completiontimestamp ==
                                          undefined && (
                                          <div className="bg-red-700 px-[5px]  rounded-full  ml-[5px]">
                                            <p className="text-[10px] text-white">
                                              {"Late"}
                                            </p>
                                          </div>
                                        ))}
                                    <p className="text-[14px] ml-[5px] break-words whitespace-normal leading-snug text-textcolor">
                                      {inneritem.task}
                                    </p>
                                  </div>
                                  <div className="flex flex-row items-start w-full ">
                                    {inneritem.employeelist.map(
                                      (empitem, empindex) => {
                                        const employeefata = employees.find(
                                          (emp) => emp.id === empitem
                                        );
                                        return (
                                          <div className="flex flex-row items-start  bg-themeblue rounded-full px-[5px] mr-[5px]">
                                            <p className="text-[10px] text-white ">
                                              {employeefata.firstname +
                                                " " +
                                                employeefata.lastname}
                                            </p>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

const generateMonthOptions = (startDate, endDate) => {
  const options = [];
  const currentDate = new Date(startDate);

  while (currentDate <= endDate) {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const label = currentDate.toLocaleDateString("default", {
      month: "long",
      year: "numeric",
    });

    options.push(
      <option key={`${year}-${month}`} value={`${year}-${month}`}>
        {label}
      </option>
    );

    currentDate.setMonth(currentDate.getMonth() + 1);
  }

  return options;
};

export default HorizontalDattePickerWrap;
